export default __webpack_public_path__ + "static/media/signup.c950a086.png";